'use client'
import React, { createContext, useContext, useState, useEffect } from 'react'

const AddDataContext = createContext<string | null>(null)

export const useAddData = () => useContext(AddDataContext)

const getAddData = async () => {
  const { getRemoteConfig, fetchAndActivate, getString, ensureInitialized } = await import('@firebase/remote-config')
  const { app } = await import('@/firebase')

  const remoteConfig = getRemoteConfig(app)
  remoteConfig.settings.minimumFetchIntervalMillis = 0

  try {
    await ensureInitialized(remoteConfig)
    await fetchAndActivate(remoteConfig)

    const addData = getString(remoteConfig, 'sponsoredAdConfig')

    return JSON.parse(addData)
  } catch (error) {
    console.error('Error fetching remote config:', error)
    return null
  }
}

export const AddDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [addData, setAddData] = useState<string | null>(null)
  useEffect(() => {
    const fetchData = async () => {
      const data = await getAddData()
      setAddData(data)
    }
    fetchData()
  }, [])
  return <AddDataContext.Provider value={addData}>{children}</AddDataContext.Provider>
}
